import { Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { CLASS_NAMES, PROPS } from './constants';
import usePrimaryEmployment from './usePrimaryEmployment';

import Employed from '../components/Employed';
import NotEmployed from '../components/NotEmployed';
import Retired from '../components/Retired';
import SelfEmployed from '../components/SelfEmployed';

const PrimaryEmployment: React.FunctionComponent = function () {
  const { employmentStatus, onGrossBlur } = usePrimaryEmployment();
  return (
    <div className={CLASS_NAMES.container}>
      <div className={CLASS_NAMES.header}>
        <Text className={CLASS_NAMES.title} text="Primary Employment" />
      </div>
      <div className="flex flex-row gap-x-3 md:gap-x-4">
        <Widget.CreditEmploymentDetailsEmploymentStatus
          {...PROPS.employmentStatus}
        />
        <Widget.CreditEmploymentDetailsGrossAnnualIncomeAmount
          {...PROPS.grossAnnualIncome}
          onBlur={onGrossBlur}
        />
      </div>
      {employmentStatus === 'employed' && <Employed type="primary" />}
      {employmentStatus === 'self_employed' && <SelfEmployed type="primary" />}
      {employmentStatus === 'not_employed' && <NotEmployed type="primary" />}
      {employmentStatus === 'retired' && <Retired type="primary" />}
    </div>
  );
};

export default PrimaryEmployment;
